import React from 'react';
import { Link } from 'react-router-dom';
import * as routes from '../../../../../../common/constants/routes';
import { formatAcceptableTime } from '../../../../../../common/helpers/date-formatting';
import {
  CampaignAcceptableTime,
  CampaignAudienceAttribute,
} from '@mm/state/model/CampaignsModel';
import ChatbotModel from '@mm/state/model/ChatbotModel';
import { BotBuilderRoutes } from '../../../../../../routes/bot-builder-routes';

type AudiencesLinkListProps = {
  audiences: CampaignAudienceAttribute[];
  chatbot: ChatbotModel;
};

const AudiencesLinkList = ({ audiences, chatbot }: AudiencesLinkListProps) => {
  const totalAudiences = audiences.length - 1;

  return (
    <>
      {audiences.map((audience, index) => (
        <Link
          key={audience.audienceId}
          className="drip-campaign-detail__read-only-field-link"
          to={BotBuilderRoutes.audiences.getLink({
            chatbotId: chatbot.id,
            audienceId: audience.audienceId,
          })}
        >
          {audience.name}
          {index !== totalAudiences && <span>, </span>}
        </Link>
      ))}
    </>
  );
};

type Props = {
  includedAudiences: CampaignAudienceAttribute[];
  excludedAudiences: CampaignAudienceAttribute[];
  chatbot: ChatbotModel;
  name: string;
  acceptableTime: CampaignAcceptableTime;
};

const ReadOnlyCampaignHeader = (props: Props) => {
  const {
    includedAudiences = [],
    excludedAudiences = [],
    chatbot,
    acceptableTime,
  } = props;

  return (
    <div className="drip-campaign-detail__read-only-fields">
      <div className="drip-campaign-detail__read-only-field">
        <span>Audience{includedAudiences.length > 1 ? 's' : ''}: </span>
        <AudiencesLinkList audiences={includedAudiences} chatbot={chatbot} />
      </div>

      {!!excludedAudiences.length && (
        <div className="drip-campaign-detail__read-only-field drip-campaign-detail__excluded-field">
          <span>
            Excluded Audience{excludedAudiences.length > 1 ? 's' : ''}:{' '}
          </span>
          <AudiencesLinkList audiences={excludedAudiences} chatbot={chatbot} />
        </div>
      )}

      <div className="drip-campaign-detail__read-only-field">
        <span>Schedule: </span>
        <span className="drip-campaign-detail__read-only-field-value">
          {formatAcceptableTime(acceptableTime)}
        </span>
      </div>
    </div>
  );
};

export default ReadOnlyCampaignHeader;
